import { GuideContract } from "../../domain/contracts/guide_contract";
import { guideEntity } from "../../domain/entities/guide";
import { guidesEntity } from "../../domain/entities/guides";
import http from "../../../../plugins/http-common"
import i18n from "../../../../i18n";

export const HttpGuideRepository = {
  ...GuideContract,
  model: guideEntity,
  model_index: guidesEntity,

  async index_by_client_guides(client_id, per_page, page, status, search, sort_by) {
    var sort = ""
    if (sort_by.length > 0) sort = '&sort=' + sort_by[0].field + '&sort_direction=' + sort_by[0].direction;

    const res = await http.get('shipping_guides_details?page=' + page + '&per_page=' + per_page + '&status=' + status + '&client_id=' + client_id + sort + "&q=" + search);

    var items = [];
    res.data.success.arguments.data.forEach( x => {
      let id = x.id;
      x = x.attributes
      x.id = id;
      x.actions = [{
          name: i18n.t('guides.details'),
          icon: {
              color: 'accent',
              icon: 'info'
          },
          link: '/guide-details/' + x.id,
          permission: "guides.show"
      }]

      items.push(x);
    })
    
    res.data.success.arguments.data = items;
    return res;
  },

  async get_guide(data) {
    const res = await http.get('/api/shipping_guides/show/' + data);

    return res;
  },

  async create_guide(data) {
    const res = await http.post('api/shipping_guides', data);

    return res;
  },

  async donwload_guides(ids) {
    const res = await http.get('api/shipping_guides/details/labels?ids=' + ids);

    return res;
  },

  async delete_guides(ids) {
    const res = await http.delete('api/shipping_guides/details/' + ids)
    
    return res;
  },

  async cancel_guides(ids) {
    const res = await http.post('api/shipping_guides/details/cancel', ids)
    
    return res;
  },
  
  async get_blob(path){
    const res = await http.get(path, { responseType:'blob' });
    
    return res;
  },

  async donwload_history_report(client_id, initial_date, final_date) {
    const res = await http.get("api/shipping_guides/history_report/" + client_id + '/' + initial_date + '/' + final_date);

    return res;
  },

  async donwload_balance_report(client_id, initial_date, final_date) {
    const res = await http.get("api/shipping_guides/balance_report/" + client_id + '/' + initial_date + '/' + final_date);

    return res;
  },
  
  async load_payments(data) {
    const res = await http.post('api/charges_guides/load_payments', data, { headers: { 'Content-Type': 'multipart/form-data' } });
    
    return res;
  },

  async load_billing(data) {
    const res = await http.post('api/charges_guides/load_billing', data, {headers: { 'Content-Type': 'multipart/form-data' } });

    return res;
  }
};